import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';

@Component({
  selector: 'argalis-apps-statisfaction-card',
  templateUrl: './statisfaction-card.component.html',
  styleUrls: ['./statisfaction-card.component.scss']
})
export class StatisfactionCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('statisfactionData')
  set _statisfactionData(value: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo) {
    this.statisfactionData = value;
  }

  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }
  public statisfactionData: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public indicator: boolean;
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
